// Подписи журнала: кто, что изменилось. Чистые функции.

import type { Change } from './api'

export const SOURCE_OPTIONS = [
  { value: '', label: 'Все источники' },
  { value: 'web', label: 'Веб' },
  { value: 'mcp', label: 'MCP-клиенты' },
  { value: 'ai', label: 'ИИ' },
  { value: 'sync', label: 'Синхронизация' },
  { value: 'import', label: 'Импорт' },
  { value: 'system', label: 'Система' },
]

const KIND_LABELS: Record<string, string> = {
  web: 'Веб',
  mcp: 'MCP',
  ai: 'ИИ',
  sync: 'Синхронизация',
  import: 'Импорт',
  system: 'Система',
}

/** «MCP · telegram-bot», «Веб», «Синхронизация · garmin». */
export function actorText(change: Pick<Change, 'actor_kind' | 'actor_label'>): string {
  const kind = KIND_LABELS[change.actor_kind] ?? change.actor_kind
  const label = change.actor_label.includes(':') ? change.actor_label.split(':').slice(1).join(':') : change.actor_label
  return label && label !== change.actor_kind ? `${kind} · ${label}` : kind
}

export const OP_LABELS: Record<Change['op'], string> = {
  create: 'Создано',
  update: 'Изменено',
  delete: 'Удалено',
  undo: 'Откат',
}

const SKIP = new Set(['id', 'created_at', 'updated_at'])

export type DiffRow = { key: string; before: string; after: string }

const show = (value: unknown): string =>
  value === null || value === undefined ? '—' : typeof value === 'object' ? JSON.stringify(value) : String(value)

/** Поля, которые различаются между «было» и «стало» (для создания и удаления — все). */
export function diffRows(change: Pick<Change, 'before' | 'after'>): DiffRow[] {
  const keys = new Set([...Object.keys(change.before ?? {}), ...Object.keys(change.after ?? {})])
  const rows: DiffRow[] = []
  for (const key of keys) {
    if (SKIP.has(key)) continue
    const before = change.before?.[key]
    const after = change.after?.[key]
    if (change.before && change.after && JSON.stringify(before) === JSON.stringify(after)) continue
    rows.push({ key, before: show(before), after: show(after) })
  }
  return rows
}
